import { MyParadiseTransponderModal } from "@app/modals/MyParadise/MyParadiseTransponderModal/MyParadiseTransponderModal"
import { useGetMyParadiseImage } from "@app/store/service/cmsService"
import { useModal } from "@tecreation/funnel-components"
import "./MyParadiseTransponder.css"

export const MyParadiseTransponder = () => {
	const { data: image } = useGetMyParadiseImage({ type: "transponder" })
	const { showModal } = useModal()

	return (
		<div
			className="myParadiseTransponder h-100"
			style={{ backgroundImage: 'url("' + image || "" + '")' }}
			onClick={() => showModal(MyParadiseTransponderModal)}
		>
			<img src={image || ""} style={{ opacity: 0, width: "100%", height: "auto" }} />
		</div>
	)
}
